import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const BUNDLE_FRAME_NORMAL = 'normal';
export const BUNDLE_FRAME_EXTRA = 'extra';
export const BUNDLE_FRAME_MOBILE = 'mobile';
export const BUNDLE_FRAME_RESULT = 'result';

const typeToClass = (type) => {
  switch (type) {
    case BUNDLE_FRAME_NORMAL:
    case BUNDLE_FRAME_EXTRA:
    case BUNDLE_FRAME_RESULT:
    case BUNDLE_FRAME_MOBILE:
      return type;
    default:
      return BUNDLE_FRAME_NORMAL;
  }
};

const BundleFrame = ({ children, type, className, isMobile }) => (
  <div
    className={cx('frame', typeToClass(type), className, {
      'frame--mobile': isMobile,
    })}
  >
    {children}
  </div>
);

BundleFrame.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf([BUNDLE_FRAME_NORMAL, BUNDLE_FRAME_EXTRA, BUNDLE_FRAME_RESULT]),
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};
export default BundleFrame;
